<template>
  <section class="calc-container">
    <div class="step-one">
      <h2>Step 1</h2>
      <div class="form-group" v-if="Object.keys(this.selectedProduct).length <= 0">
        <vToken2
          v-model="selectedProduct"
          :options="productSearchOptions"
          @token2-select="handleProductSelection">
        </vToken2>
      </div>
      <div class="form-group" v-else style="display: none;">
        <vToken2
          v-model="selectedProduct">
        </vToken2>
      </div>
      <div class="product-container" v-if="Object.keys(this.selectedProduct).length > 0">
        <a :href="'/shop/cerakote-coating/'+selectedProduct.sku" target="_blank">
          <img :src="`${selectedProduct.featured_image_url}&size=100`" :alt="selectedProduct.name"
               v-if="selectedProduct.featured_image_url !== null && selectedProduct.featured_image_url.includes('?')">
          <img :src="`${selectedProduct.featured_image_url}?size=100`" :alt="selectedProduct.name"
               v-else-if="selectedProduct.featured_image_url !== null">
          <img src="/img/default-product-img.png" alt="image coming soon" v-else>
          <h3>{{ selectedProduct.name }}</h3>
          <p>{{ selectedProduct.sku }}</p>
        </a>
      </div>
      <div class="product-container" v-else><i class="fa fa-flask"></i></div>
    </div>
    <div class="alert-danger error-msg" v-if="formErrors.length">
      <span v-for="formError in formErrors" :key="formError" v-html="formError"></span>
    </div>
    <div class="step-two">
      <form>
        <h2>Step 2</h2>
        <h5>Select Mixing Ratio</h5>
        <div v-if="selectedProduct.sku === 'SG-200'">
          <div class="form-check">
            <input v-model="ratio" type="radio" name="ratio-9" id="ratio-9" value="9" checked
                   :disabled="!validForm" @change="resetWeights">
            <label for="ratio-9">
              9:1
            </label>
          </div>
        </div>
        <div v-else-if="selectedProduct?.sku?.startsWith('F-') || selectedProduct?.sku?.startsWith('FIR-')">
          <div class="form-check">
            <input v-model="ratio" type="radio" name="ratio-6" id="ratio-6" value="6" checked
                   :disabled="!validForm" @change="resetWeights">
            <label for="ratio-6">
              6:1 (higher gloss)
            </label>
          </div>
          <div class="form-check">
            <input v-model="ratio" type="radio" name="ratio-9" id="ratio-9" value="9" checked
                   :disabled="!validForm" @change="resetWeights">
            <label for="ratio-9">
              9:1 (recommended gloss)
            </label>
          </div>
          <div class="form-check">
            <input v-model="ratio" type="radio" name="ratio-12" id="ratio-12" value="12" checked
                   :disabled="!validForm" @change="resetWeights">
            <label for="ratio-12">
              12:1 (lower gloss)
            </label>
          </div>
          <div class="form-check">
            <label for="other">
              Other
            </label>
            <input v-model="ratio" type="number" value="" min="12" max="24" :disabled="!validForm"
                   @change="resetWeights">
          </div>
        </div>
        <div v-else>
          <div class="form-check">
            <input v-model="ratio" type="radio" name="ratio-12" id="ratio-12" value="12" :disabled="!validForm"
                   @change="resetWeights">
            <label for="ratio-12">
              12:1 (higher gloss)
            </label>
          </div>
          <div class="form-check">
            <input v-model="ratio" type="radio" name="ratio-18" id="ratio-18" value="18" checked
                   :disabled="!validForm" @change="resetWeights">
            <label for="ratio-18">
              18:1 (recommended gloss)
            </label>
          </div>
          <div class="form-check">
            <input v-model="ratio" type="radio" name="ratio-24" id="ratio-24" value="24" :disabled="!validForm"
                   @change="resetWeights">
            <label for="ratio-24">
              24:1 (lower gloss)
            </label>
          </div>
          <div class="form-check">
            <label for="other">
              Other
            </label>
            <input v-model="ratio" type="number" value="" min="12" max="24" :disabled="!validForm"
                   @change="resetWeights">
          </div>
        </div>
        <h5>Enter {{ $root.domainName }} Weight (g)</h5>
        <input type="number" step="1" min="0" name="weight" v-model="weight" class="form-control"
               :disabled="!validForm" @change="resetWeights">
        <br>
        <div>
          <button class="btn btn-blue" type="submit" @click.prevent="calculate"
                  :disabled="loading || !validForm || ratio === ''"><i class="fa fa-calculator"></i> Calculate <i
            class="fa fa-spin fa-spinner" v-if="loading"></i></button>
          <button class="btn btn-black" @click="reset" :disabled="loading || !validForm"><i class="fa fa-eraser"></i>
            Reset
          </button>
        </div>
      </form>
    </div>
    <div class="catalyst-weight">
      <h5>Your Catalyst Weight (g)</h5>
      <p class="result-label" :title="catalystWeight">{{ catalystWeight }}</p>
    </div>
    <div class="total-weight">
      <h5>Your Total Weight (g)</h5>
      <p class="result-label" :title="totalWeight">{{ totalWeight }}</p>
    </div>
  </section>
</template>

<script>
import vToken2 from './global/Token2.vue'

export default {
  name: 'catalyst-mixing-calculator',
  components: {
    vToken2
  },
  data() {
    return {
      selectedProduct: {},
      urlSku: window.location.href.split('?sku=')[1],
      ratio: '',
      weight: 0,
      catalystWeight: '0.0',
      totalWeight: '0.0',
      formErrors: [],
      loading: false,
      productSearchOptions: {
        placeholder: 'Select a product',
        multiple: false,
        ajax: {
          url: '/api/proxify/domains/cerakote/shop/products' +
            '?anycat=cera_h_series%2Ccera_elite%2Ccera_nir_signature%2Ccera_mixingcalculator&fields=id,name,sku,featured_image_url.**&hide_hero_only=false',
          delay: 150,
          cache: false,
          data(params) {
            return {
              q: params.term,
            };
          },
          processResults(data, params) {
            return {results: data.data};
          },
        },
        templateResult(item) {

          if (item.loading) {
            return item.text;
          }
          return `${item.name} ${item.sku}`;
        },
        templateSelection(item) {
          return item.text;
        },
      },
    };
  },
  created() {
    //loads the sku into the calculator if the user has navigated from a product detail page
    if (this.urlSku !== undefined) {

      let productSearch = this.productSearchOptions.ajax.url;
      let queryParams = {
        q: this.urlSku
      };

      axios.get(productSearch, {params: queryParams})
        .then(response => (this.selectedProduct = response.data.data[0]));
    }
  },
  computed: {
    validForm() {
      if (Object.keys(this.selectedProduct).length > 0) {
        return true;
      }

      return false;
    }
  },
  methods: {
    resetWeights() {
      this.catalystWeight = '0.0';
      this.totalWeight = '0.0';
    },

    async calculate() {
      let vm = this;
      vm.formErrors = [];

      this.loading = true;

      try {
        let catalystWeightUrl = `/api/proxify/domains/cerakote/shop/products/${vm.selectedProduct.id}/catalyst-weight`;
        let queryParams = {
          weight: vm.weight,
          ratio: vm.ratio
        };

        let response = await axios.get(catalystWeightUrl, {params: queryParams});

        vm.catalystWeight = parseFloat(response.data).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        vm.totalWeight = parseFloat(parseFloat(response.data) + parseFloat(vm.weight)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } catch (error) {
        vm.formErrors.push(error.response.data.message + '.<br>');
        vm.formErrors.push('For calculating the catalyst mix please contact us at <a href="tel:1-866-774-7628">1-866-774-7628</a>');
      }

      this.loading = false;
    },

    async handleProductSelection(product) {
      this.selectedProduct = product;

      if (product.sku === 'SG-200') {
        this.ratio = '9';
      }
    },

    reset() {
      this.selectedProduct = {};
      this.catalystWeight = '0.0';
      this.totalWeight = '0.0';
      this.weight = 0;
      this.ratio = '';
      this.formErrors = [];

      //removes the query string when the reset button is clicked
      window.history.pushState({}, "", window.location.href.split('?sku=')[0]);
    }
  }
}
</script>
